/**
 * Join codes identify a hosted game. The alphabet drops characters that are easy to confuse
 * when read aloud or typed with a VR keyboard (0/O, 1/I/L).
 */
export const JOIN_CODE_ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
export const JOIN_CODE_LENGTH = 6;

/**
 * `random` must return a number in [0, 1). It is the caller's: the core draws nothing of its own
 * (the server passes its `Math.random`; a test, a seeded `createRng`).
 */
export function generateJoinCode(random: () => number): string {
  let code = '';
  for (let i = 0; i < JOIN_CODE_LENGTH; i++) {
    const index = Math.min(
      JOIN_CODE_ALPHABET.length - 1,
      Math.floor(random() * JOIN_CODE_ALPHABET.length),
    );
    code += JOIN_CODE_ALPHABET[index];
  }
  return code;
}

/** Upper-cases and strips separators so "k7pq-2x" and "K7PQ 2X" both become "K7PQ2X". */
export function normalizeJoinCode(input: string): string {
  return input.toUpperCase().replace(/[\s-_.]/g, '');
}

export function isValidJoinCode(code: string): boolean {
  return (
    code.length === JOIN_CODE_LENGTH && [...code].every((ch) => JOIN_CODE_ALPHABET.includes(ch))
  );
}
